import React, { useEffect, useState } from "react";
import Select from "@mui/material/Select";
import { OutlinedInput } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import "./SelectInput.css";

const renderHeading = (heading) => {
  if (typeof heading !== "string") return heading;
  const trimmed = heading.trimEnd();
  if (!trimmed.endsWith("*")) return heading;
  return (
    <>
      {trimmed.slice(0, -1)}
      <span style={{ color: "red" }}>*</span>
    </>
  );
};

const MenuProps = {
  PaperProps: {
    style: {
      outline: "0px",
      border: "0px",
      maxHeight: 300,
      overflowY: "auto",
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "20px",
  };
}

const getElementValue = (ele) => {
  if (ele === null || ele === undefined) return "";
  if (typeof ele === "object") {
    const idKey = Object.keys(ele).find(
      (key) => key.toLowerCase() === "id" || key.toLowerCase().endsWith("id")
    );
    if (idKey && ele[idKey] !== undefined && ele[idKey] !== null) {
      return ele[idKey];
    }
    if (ele.value !== undefined && ele.value !== null) return ele.value;
    if (ele.name !== undefined && ele.name !== null) return ele.name;
    return "";
  }
  return ele;
};


const SelectInput = ({
  onChange,
  list,
  value,
  example,
  heading,
  height = 40,
  style,
  defaultVal,
  disabled,
  error,
  onFocus,
  showExample = true,
}) => {
  const getCurrentValueId = (val) => {
    return getElementValue(val)
  };

  const [listVal, setListVal] = useState(() => getCurrentValueId(value));

  useEffect(() => {
    const newVal = getCurrentValueId(value);

    setListVal(newVal);
  }, [value]);

  useEffect(() => {
    if (defaultVal) {
      const newVal = getCurrentValueId(defaultVal);
      setListVal(newVal);
    }
  }, [defaultVal]);

  const handleList = (val) => {
    setListVal(val);
    const selectedObj = (Array.isArray(list) ? list : []).find((ele) => getElementValue(ele) === val);

    onChange(selectedObj || val);
  };

  return (
    <div className={`selectInputContainer ${error ? "error" : ""}`}>
      {heading && (
        <div className="selectInputHeading">{renderHeading(heading)}</div>
      )}
      <div style={{ height: height || "34px" }}>
        <Select
          displayEmpty
          disabled={disabled}
          onFocus={onFocus}
          style={{
            height: "100%",
            width: "100%",
            borderRadius: "8px",
            borderColor: "#e2e2e5",
            outline: "none",
            boxShadow: "none",
            cursor: disabled ? "not-allowed" : "pointer",
            backgroundColor: disabled ? "#e8e9e8" : "#fff",
            ...style,
          }}
          value={listVal} // Make sure listVal === "" initially if nothing is selected
          onChange={(e) => handleList(e.target.value)}
          input={<OutlinedInput />}
          renderValue={(selectedId) => {
            if (!selectedId || selectedId === "") {
              return (
                <span className="exp_text" style={{ color: "#aaa" }}>
                  {example}
                </span>
              );
            }
            const selectedObj = (Array.isArray(list) ? list : []).find(
              (ele) => getElementValue(ele) === selectedId,
            );

            // If we found the object, display its readable name
            if (selectedObj) {
              return (
                <span className="exp_text">
                  {selectedObj?.level ||
                    selectedObj?.name ||
                    selectedObj?.type ||
                    selectedObj?.rating ||
                    selectedObj?.value ||
                    selectedObj?.acronym ||
                    selectedObj?.userName ||
                    selectedObj?.consumerName ||
                    selectedObj?.generatorName ||
                    selectedObj?.entityName ||
                    selectedObj?.walletAccountType ||
                    (typeof selectedObj === "object" ? "" : selectedObj)}
                </span>
              );
            }

            // If no object found, show placeholder instead of raw ID
            return (
              <span className="exp_text" style={{ color: "#aaa" }}>
                {example}
              </span>
            );
          }}
          MenuProps={MenuProps}
          inputProps={{ "aria-label": "Without label" }}
        >
          {showExample && (
            <MenuItem value="">
              <span className="exp_text">{example}</span>
            </MenuItem>
          )}

          {(Array.isArray(list) ? list : []).map((ele, index) => {
            const itemKey = (ele && typeof ele === "object")
              ? (ele.id !== undefined && ele.id !== null ? ele.id : `item-${index}`)
              : (ele !== null && ele !== undefined ? ele : `item-${index}`);

            const itemVal = getElementValue(ele);

            return (
              <MenuItem
                key={itemKey}
                value={itemVal}
                style={getStyles()}
              >
                <span className="exp_text">
                  {ele?.name ||
                    ele?.level ||
                    ele?.discomName ||
                    ele?.type ||
                    ele?.rating ||
                    ele?.value ||
                    ele?.acronym ||
                    ele?.userName ||
                    ele?.consumerName ||
                    ele?.generatorName ||
                    ele?.entityName ||
                    ele?.walletAccountType ||
                    (typeof ele === "object" ? "" : ele)}
                </span>
              </MenuItem>
            );
          })}

        </Select>
      </div>
      {error && <div className="errorHeadingSelect">{error}</div>}
    </div>
  );
};

export default SelectInput;
